import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';

@Component({
  selector: 'app-vessel-registry',
  standalone: true,
  imports: [
    CommonModule, 
    MatCardModule, 
    MatButtonModule, 
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule
  ],
  template: `
    <div class="vessel-registry-container">
      <mat-card class="main-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon class="title-icon">boat</mat-icon>
            Vessel Registry
          </mat-card-title>
          <mat-card-subtitle>
            Comprehensive vessel registration and management system
          </mat-card-subtitle>
        </mat-card-header>
        
        <mat-card-content>
          <p class="description">
            Manage vessel registrations, track vessel specifications, and monitor compliance 
            requirements. Access detailed vessel information including ownership, specifications, 
            and operational history.
          </p>
          
          <div class="registry-grid">
            <div class="registry-item">
              <mat-icon class="registry-icon">person</mat-icon>
              <h3>Ownership</h3>
              <p>Track vessel ownership and registration details</p>
            </div>
            
            <div class="registry-item">
              <mat-icon class="registry-icon">build</mat-icon>
              <h3>Specifications</h3>
              <p>Manage vessel specifications and equipment</p>
            </div>
            
            <div class="registry-item">
              <mat-icon class="registry-icon">verified</mat-icon>
              <h3>Compliance</h3>
              <p>Monitor safety and regulatory compliance</p>
            </div>
          </div>
        </mat-card-content>
        
        <mat-card-actions>
          <button mat-raised-button color="primary">
            <mat-icon>boat</mat-icon>
            View Vessels
          </button>
          <button mat-button>
            <mat-icon>add</mat-icon>
            Register Vessel
          </button>
          <button mat-button>
            <mat-icon>edit</mat-icon>
            Update Registry
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  `,
  styles: [`
    .vessel-registry-container {
      padding: 2rem;
      max-width: 1200px;
      margin: 0 auto;
    }
    
    .main-card {
      margin-bottom: 2rem;
    }
    
    .title-icon {
      margin-right: 8px;
      color: #1976d2;
    }
    
    .description {
      color: #666;
      line-height: 1.6;
      margin-bottom: 2rem;
    }
    
    .registry-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 1.5rem;
      margin-bottom: 2rem;
    }
    
    .registry-item {
      text-align: center;
      padding: 1rem;
      border-radius: 8px;
      background: #f8f9fa;
      transition: transform 0.2s;
    }
    
    .registry-item:hover {
      transform: translateY(-2px);
    }
    
    .registry-icon {
      font-size: 2rem;
      width: 2rem;
      height: 2rem;
      color: #1976d2;
      margin-bottom: 0.5rem;
    }
    
    .registry-item h3 {
      margin: 0.5rem 0;
      color: #333;
      font-size: 1.1rem;
    }
    
    .registry-item p {
      margin: 0;
      color: #666;
      font-size: 0.9rem;
    }
    
    mat-card-actions {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
    }
    
    mat-card-actions button {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    
    @media (max-width: 768px) {
      .vessel-registry-container {
        padding: 1rem;
      }
      
      .registry-grid {
        grid-template-columns: 1fr;
      }
      
      mat-card-actions {
        flex-direction: column;
      }
    }
  `]
})
export class VesselRegistryComponent {
  constructor() {}
} 